import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appProviders } from './app/app.providers';

bootstrapApplication(AppComponent, { providers: [provideZoneChangeDetection({ eventCoalescing: true }), ...appProviders] })
  .catch(err => console.error(err));
